import React from 'react';
import { Component } from '@poa/core';
import { observable } from '@poa/state';
import RefreshIcon from '../../icons/refresh';

const placeholederManImage = require('../../../img/placeholder_man.jpg');
const placeholederImage = require('../../../img/placeholder.jpg');


class GeneralDialogsList extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa
    env; // injected by Poa

    localState = observable({
        dialogItem: null,
        expanded: false,
        dialogs: [],
    });

    getSenderName = (sender) => {
        if (sender.id === this.store.generalProfile.selectedProfile.payer_id || sender.first_name === 'Me') {
            return null;
        }

        const fullName1 = [sender.first_name, sender.last_name]
            .filter(Boolean)
            .join(' ');
        
        if (fullName1) {
            return fullName1;
        }
        const fullName = [sender.firstName, sender.lastName]
            .filter(Boolean)
            .join(' ');
        
        return fullName || sender.id;
    };

    async componentDidMount() {
        try {

            const data = await this.env.http
                .get(`chat_list/${this.store.generalProfile.selectedProfile.payer_id}/`)
                .then(response => response.data);

            this.localState.dialogs = data.chats.map((dialog) => {
                return {
                    id: dialog.id,
                    date_created: dialog.date_created,
                    name: dialog.senders.map(sender => {
                        return this.getSenderName(sender);
                    }),
                    msgs: dialog.msg_qty,
                    last_activity: dialog.last_msg_date,
                };
            });
        } catch (e) {
            console.log(e);
            this.env.alert(
                'Ошибка',
                `Ошибка. Данные не получены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
            );
        }
    }

    handlChildrenListItemClick = async (index) => {

        try {

            const data = await this.env.http
                .get(`chats/${index}/`)
                .then(response => response.data);

            this.localState.dialogItem = data.data;
        } catch (e) {
            console.log(e);
            this.env.alert(
                'Ошибка',
                `Ошибка. Данные не получены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
            );
        }
    }

    buildListBody = () => {
        if (!this.localState.dialogs)
            return null;

        const body = this.localState.dialogs.map((dialog, idx) => {

            return (
                <tr key={dialog.id} onClick={() => this.handlChildrenListItemClick(dialog.id)}>
                    <td style={{ flex: 1, alignItems: 'right', paddingLeft: '20px' }}>{dialog.date_created}</td>
                    <td style={{ flex: 1, color: "blue" }}>{dialog.name}</td>
                    <td style={{ flex: 1, alignItems: 'center' }}>{dialog.msgs}</td>
                    <td style={{ flex: 1, alignItems: 'center' }}>{dialog.last_activity}</td>
                </tr>
            );
        }
        );
        return (body)
    }

    handleDialogAction = async (actionType) => {
        try {
            await this.env.http.post(`chats/${this.localState.dialogItem.id}/${actionType}/`);
            this.env.alert(
                'Успех',
                `Действие "${actionType === 'events' ? 'Ивенты' : 'Описание'}" выполнено успешно.`
            );
        } catch (e) {
            console.log(e);
            this.env.alert(
                'Ошибка',
                `Ошибка. Действие не выполнено.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
            );
        }
    }

    handleRefreshDialog = async () => {
        console.log('Refreshing dialog data...');
        try {
            const data = await this.env.http
                .get(`chats/${this.localState.dialogItem.id}/`)
                .then(response => response.data);
            this.localState.dialogItem = data.data;
        } catch (e) {
            console.log(e);
            this.env.alert(
                'Ошибка',
                `Ошибка. Данные не получены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
            );
        }
    }

    buildDialogItem = () => {

        return (
            <>
                <div className='name-row'>
                    <button className='back-button' onClick={() => {
                        this.localState.dialogItem = null;
                    }}>
                        {`<-`} Назад
                    </button>

                    <div className='title-name'>
                        {this.localState.dialogItem.senders.map(sender => {
                        return this.getSenderName(sender);
                    })}
                    </div>

                    <button className='back-button' style={{
                        width: 'fit-content',
                    }} onClick={this.handleRefreshDialog}>
                        Обновить {<RefreshIcon />}
                    </button>
                </div>
                <div className='finance-row'>
                    <div className='info-card'>
                        <div className='info-title'>Сообщений</div>
                        <div className='info-value'>{this.localState.dialogItem.msg_qty}</div>
                    </div>
                    <div className='info-card'>
                        <div className='info-title'>Последнее</div>
                        <div className='info-value__black'>{this.localState.dialogItem.last_msg_date}</div>
                    </div>
                    <div className='info-card'>
                        <div className='info-title'>Описание</div>
                        <div className='info-value__black'>{this.localState.dialogItem.summary_date}</div>
                    </div>
                    <div className='info-card'>
                        <div className='info-title'>Ивенты</div>
                        <div className='info-value__black'>{this.localState.dialogItem.events_date}</div>
                    </div>
                </div>

                <div className='general-dialog-layouts'>

                    <div className='column-content'>
                        <div className='finance-row'>
                            <div className='info-chart-card' style={{ minHeight: 'auto' }}>
                                <div className='info-header'>
                                    <div className='info-title'>Описание</div>
                                    <div className='info-title_right' onClick={() => {
                                        this.handleDialogAction('summary')
                                    }}>
                                        Обновить {'>'}
                                    </div>
                                </div>
                                <div className='info-description'>
                                    <div 
                                        className={`description-text${this.localState.expanded ? ' expanded' : ''}`}
                                        dangerouslySetInnerHTML={{
                                            __html: (this.localState.dialogItem.summary || 'Нет описания')
                                                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                                                .replace(/\*(.*?)\*/g, '<em>$1</em>')
                                                .replace(/`(.*?)`/g, '<code>$1</code>')
                                                .replace(/\n/g, '<br>')
                                        }}
                                    />
                                    <button className='info-description__expand'
                                        onClick={() => {
                                            this.localState.expanded = !this.localState.expanded;
                                        }}>
                                        {this.localState.expanded ? 'Свернуть' : 'Развернуть'}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='finance-row'>
                            <div className='info-chart-card account'>
                                <div className='info-header'>
                                    <div className='info-title'>Диалог</div>
                                </div>
                                <ul className='card-dialog-list'>
                                    {this.localState.dialogItem.msges.map((dialog, idx) => {
                                        return (
                                            <li key={idx} className='card-dialog-item'>

                                                <div className='card-dialog-avatar'>
                                                    <img
                                                        src={
                                                            (dialog.name === 'Me ' || dialog.sender_id === this.store.generalProfile.selectedProfile.payer_id) ? 
                                                            placeholederImage : 
                                                            placeholederManImage
                                                            
                                                        }
                                                        onError={(e) => { e.target.src = placeholederImage; }}
                                                        alt={dialog.name} />
                                                </div>
                                                <div className='card-dialog-content'>
                                                    <div className='card-dialog-title'>
                                                        <div className='card-dialog-name'>{dialog.name}</div>
                                                        <div className='card-dialog-date'>{dialog.date_created}</div>
                                                    </div>
                                                    <div 
                                                        className='card-dialog-text'
                                                        dangerouslySetInnerHTML={{
                                                            __html: dialog.content
                                                                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                                                                .replace(/\*(.*?)\*/g, '<em>$1</em>')
                                                                .replace(/`(.*?)`/g, '<code>$1</code>')
                                                                .replace(/\n/g, '')
                                                        }}
                                                    />
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='sidebar-content'>
                        <div className='finance-row'>

                            <div className='info-chart-card events'>
                                <div className='info-header'>
                                    <div className='info-title'>Events</div>
                                    <div className='info-title_right' onClick={() => {
                                        this.handleDialogAction('events');
                                    }}>
                                        Обновить {'>'}
                                    </div>
                                </div>

                                <ul className='card-dialog-list'>
                                    {this.localState.dialogItem.events.map((event, idx) => {
                                        return (
                                            <li key={idx} className='card-dialog-item'>
                                                <div className='card-dialog-content'>
                                                    <div className='card-dialog-name'>{event.event_type}</div>
                                                    <div 
                                                        className='card-dialog-text'
                                                        style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', backgroundColor: '#f2f9f0' }}
                                                    >{event.event_data}</div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>


            </>
        );
    }

    render() {

        return (
            <div className='general_info__content'>
                {
                    this.localState.dialogItem ?
                        this.buildDialogItem()
                        :
                        <div className='shift-row'>
                            <div className='links-page-body'>
                                <div className='links-page_popup_content'>
                                    <table className='table' style={{
                                        tableLayout: 'fixed',
                                        border: '1px solid #ddd',
                                    }}>
                                        <thead className='links-page-thead' >
                                            <tr>
                                                <th style={{ flex: 1, paddingLeft: '2rem' }}>Начало</th>
                                                <th style={{ flex: 1, paddingLeft: '2rem' }}>Название</th>
                                                <th style={{ flex: 1, paddingLeft: '2rem' }}>К-во</th>
                                                <th style={{ flex: 1, paddingLeft: '2rem' }}>Последнее</th>
                                            </tr>
                                        </thead>
                                        <tbody className='links-page-tbody'>
                                            {this.buildListBody()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default Component({ namespaces: ['general-dialogs'] })(GeneralDialogsList);